/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TouchableOpacity, StyleProp, ViewStyle } from "react-native";

import { Text } from "UpduoLibrary";
import { skaleBlue, skaleWebTextLightGray } from "config/UpduoColors";
import { title } from "config/Utilities";

export default function SkillEditTab({ shownView, type, onPress }) {
  const color = shownView === type ? skaleBlue : skaleWebTextLightGray;
  return (
    <TouchableOpacity
      style={
        {
          width: 200,
          borderBottomWidth: 3,
          alignItems: "center",
          marginHorizontal: 10,
          marginTop: 20,
          borderColor: color,
          outline: "none",
        } as StyleProp<ViewStyle>
      }
      onPress={onPress}
    >
      <Text style={{ color, marginBottom: 3 }} isHeading={true}>
        {title(type)}
      </Text>
    </TouchableOpacity>
  );
}
